import React, { useState } from 'react'
import Button from '../../components/Button'
import { useFormik } from 'formik'
import Select from 'react-select'
import { Form } from 'react-bootstrap'
import styles from './styles.module.css'

const organizationSelectStyles = {
    control: (base) => ({
        ...base,
        minHeight: 42,
        height: 'auto',
        border: '1px solid #c8c7c7',
        borderRadius: 4,
        boxShadow: 'none',
        '&:hover': {
            borderColor: '#999'
        },
        '&:focus-within': {
            borderColor: '#80bdff',
            boxShadow: '0 0 0 0.2rem rgba(0, 123, 255, .25)'
        }
    }),
    valueContainer: (base) => ({
        ...base,
        padding: '4px 8px'
    }),
    // длинное выбранное название переносится на несколько строк
    singleValue: (base) => ({
        ...base,
        maxWidth: 'calc(100% - 30px)',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: 1.3
    }),
    // ширина списка ограничена шириной поля выбора
    menu: (base) => ({
        ...base,
        width: '100%',
        borderRadius: 4,
        overflow: 'hidden'
    }),
    // длинные названия в списке переносятся на несколько строк
    option: (base) => ({
        ...base,
        height: 'auto',
        padding: '8px 12px',
        whiteSpace: 'normal',
        wordBreak: 'break-word',
        lineHeight: 1.3
    })
}

export default function LoginForm({
    teacherMode,
    onSubmit,
    orgList,
    loading
}) {
  
    const [passVisible, setPassVisible] = useState(false)

    const authForm = useFormik({
        initialValues: {},
        onSubmit: onSubmit
      });

    const organizationOptions = (orgList || []).map(org => ({
        value: org.idOrganization,
        label: org.OrgName
    }))

    const selectedOrganization = organizationOptions.find(
        option => option.value === authForm.values.organization
    ) || null

    // поиск по названию без учёта регистра
    const filterOrganizations = (option, inputValue) =>
        option.data.label.toLowerCase().includes(inputValue.toLowerCase().trim())

    return (
        <form onSubmit={authForm.handleSubmit}>
            {teacherMode &&
            <div className={styles.orgSelect}>
                <Select
                    name='organization'
                    inputId='organization'
                    aria-label='Учебное заведение'
                    options={organizationOptions}
                    value={selectedOrganization}
                    onChange={(option) => authForm.setFieldValue('organization', option ? option.value : '')}
                    placeholder='Выбрать учебное заведение'
                    noOptionsMessage={() => 'Учебные заведения не найдены'}
                    isClearable
                    isSearchable
                    filterOption={filterOrganizations}
                    menuPlacement='auto'
                    menuPosition='fixed'
                    maxMenuHeight={280}
                    styles={organizationSelectStyles}
                />
            </div>
            }
            <input
                name='username'
                value={authForm.username}
                onChange={authForm.handleChange}
            />
            <input
                name='password'
                type={passVisible ? 'text' : 'password'}
                value={authForm.password}
                onChange={authForm.handleChange}
            />

            <div>
                <Form.Check
                    label='показать пароль'
                    style={{float: 'right'}}
                    checked={passVisible}
                    onChange={() => setPassVisible(!passVisible)}
                />
            </div>

            <Button
                type='submit'
                label={"Войти"}
                style={{marginTop: '10px'}}
                // submitting={loading}
            />
        </form>
    )
}
